/* tslint:disable:indent */

export class AudioStream{
	id: number;
	webpage: string;
	player: number;
	streamUrl: string;
	streamStatus: number;

	constructor(id: number, webpage: string, player: number, streamUrl: string, streamStatus: number) {
		this.id = id;
		this.webpage = webpage;
		this.player = player;
		this.streamUrl = streamUrl;
		this.streamStatus = streamStatus;
	}

	getPlayerName(): string{
		switch (this.player) {
			case 1: return 'Full with artwork';
			case 2: return 'Simple with artwork';
			case 3: return 'Simple no artwork';
			case 4: return 'Fixed bottom';
		}
	}
}





